import { CheckCheck } from 'lucide-react'
import { PEOPLE, type Assignee } from '../lib/types'

type Props = {
  filter: Assignee | 'all'
  onFilterChange: (filter: Assignee | 'all') => void
  doneCount: number
  onOpenDone: () => void
}

export function Header({ filter, onFilterChange, doneCount, onOpenDone }: Props) {
  return (
    <header className="sticky top-0 z-20 border-b border-cream-200 bg-cream/85 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-3 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <img src="/lantern-logo.svg" alt="Lantern" className="h-6" />
          <span className="hidden text-sm font-medium text-muted sm:inline">TODOs</span>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <div
            role="radiogroup"
            aria-label="Filter by assignee"
            className="flex items-center gap-1 rounded-full bg-white p-1 ring-1 ring-cream-200"
          >
            <button
              type="button"
              role="radio"
              aria-checked={filter === 'all'}
              onClick={() => onFilterChange('all')}
              className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
                filter === 'all' ? 'bg-teal text-white' : 'text-muted hover:bg-cream-100'
              }`}
            >
              Everyone
            </button>

            {PEOPLE.map((person) => {
              const selected = filter === person.id
              return (
                <button
                  key={person.id}
                  type="button"
                  role="radio"
                  aria-checked={selected}
                  aria-label={person.name}
                  title={person.name}
                  onClick={() => onFilterChange(selected ? 'all' : person.id)}
                  className={`rounded-full transition ${
                    selected
                      ? 'ring-2 ring-teal ring-offset-1'
                      : 'opacity-70 grayscale hover:opacity-100 hover:grayscale-0'
                  }`}
                >
                  <img src={person.avatar} alt="" className="size-7 rounded-full object-cover" />
                </button>
              )
            })}
          </div>

          <button
            type="button"
            onClick={onOpenDone}
            className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-2 text-xs
                       font-semibold text-ink ring-1 ring-cream-200 transition hover:ring-teal-300"
          >
            <CheckCheck className="size-4 text-grass" />
            Done
            {doneCount > 0 && <span className="text-faint tabular-nums">{doneCount}</span>}
          </button>
        </div>
      </div>
    </header>
  )
}
